<template>
    <div v-if="showModal">
        
        <div class="modal">
            <span>
                <img v-if="!isMobile()" v-on:click="cross_clicked" class="close" src="../assets/cancel.svg"/>
                <img v-else v-on:click="cross_clicked" class="close-mobile" src="../assets/cancel.svg"/>
            </span>
            <UpvoteButton v-if="!isMobile()" @write_upvotes="write_upvotes" class="upvote-btn" :upvoted_by="sub.upvoted_by" :num_upvotes="sub.upvotes"></UpvoteButton>
            <UpvoteButton v-else @write_upvotes="write_upvotes" class="upvote-btn-mobile" :upvoted_by="sub.upvoted_by" :num_upvotes="sub.upvotes"></UpvoteButton>
            <div class="modal-content">
                <div v-if="!isMobile()" class="problem-text embed-responsive embed-responsive-1by1">
                    <object type="application/pdf" :data="sub.submission_url + '#toolbar=0&navpanes=0&scrollbar=0&zoom=58'">
                    </object>
                </div>
                <div v-else class="modal-mobile">
                    <div class="download-text text-center">Download the submission below to view on mobile</div><br>
                     <a class="download-btn" :href="sub.submission_url" download>DOWNLOAD SUBMISSION</a><br>
                </div>
            </div>
            
        </div>
    </div>
    
</template>

<script>
import UpvoteButton from '@/components/UpvoteButton.vue'
import firebase from '../services/firebase'

export default {
    data() {
        return {
            showModal: false,
            sub: {}
        }
    },
    components: {
        UpvoteButton
    },
    name: 'SubmissionModal',
    methods: {
        show: function(submission) {
            this.showModal = true;
            this.sub = submission;
        },
        hide: function() {
            this.showModal = false;
        },
        cross_clicked: function() {
            this.$emit('cross_clicked');
        },
        write_upvotes: function(num_upvotes, upvoted_arr) {
            firebase.database().ref('submissions/challenges/' + this.$route.params.slug + '/' + this.sub.user_id).update({upvotes: num_upvotes});
            firebase.database().ref('submissions/challenges/' + this.$route.params.slug + '/' + this.sub.user_id).update({upvoted_by: upvoted_arr});
            //alert("upvotes are set and route is " + this.$route.params.slug + ' user id is ' + this.sub.user_id);
        },
        isMobile: function() {
            if (navigator.userAgent.match(/Android/i)) {
                return true;
            } else if (navigator.userAgent.match(/iPhone/i)) {
                return true;
            } else if (navigator.userAgent.match(/iPad/i)) {
                return true;
            } else {
                return false;
            }
        }
    }
}
</script>


<style scoped>

.modal {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    padding-top: 0%; /* Location of the box */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0,0.7); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
    background-color: #fefefe;
    width: 81%;
    margin-left:9%;
    margin-right:10%;
    margin-top:2%;
}

/* The Close Button */
.close {
    width: 12px;
    height: 12px;
    margin-right: 5%;
    margin-top: 1.5%;
    float: right;
    font-weight: bold;
    opacity: none;
}

.close-mobile {
    width: 12px;
    height: 12px;
    margin-right: 5%;
    margin-top: 5%;
    float: right;
    font-weight: bold;
    opacity: none;
}

.close-mobile:hover,
.close-mobile:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.download-text {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
    margin-right: 20px;
}

.upvote-btn {
    float: right;
    margin-right: -3%;
    margin-top:42%;
    padding: 0px;
}

.upvote-btn-mobile {
    float: right;
    margin-right: -3%;
    margin-top:42%;
    margin-bottom: 5%;
    padding: 0px;
}

.download-btn {
    margin-top:8%;
    margin-bottom: 8%;
    padding-top:4%;
    padding-bottom:4%;
    padding-left:6%;
    padding-right:6%;
    justify-content: center;
    width:80%;
    margin-bottom:0.5%;
    background-color:#f25792;
    border-color:#f25792;
    color:#fff;
    font-size:0.9rem;
    cursor: pointer;
    border-radius: 7px;
}

.modal-mobile {
    margin-top: 0px;
    margin-bottom: 30px;
}

</style>
